import { render, staticRenderFns } from "./regUser.vue?vue&type=template&id=894ac224"
import script from "./regUser.vue?vue&type=script&lang=js"
export * from "./regUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports